import React from 'react';

type PlanDesignControlsProps = {
  isConnected: boolean;
  isGenerating: boolean;
  isAuditMode: boolean;
  setAutoLoopState: (state: 'IDLE' | 'WAITING_FOR_GEN' | 'WAITING_FOR_AUDIT') => void;
  setLoopCount: (count: number) => void;
  onDirectSend: (text: string) => void;
};

export const PlanDesignControls: React.FC<PlanDesignControlsProps> = ({
  isConnected,
  isGenerating,
  isAuditMode,
  setAutoLoopState,
  setLoopCount,
  onDirectSend
}) => {
  return (
    <div className="flex gap-2 overflow-x-auto pb-1 scrollbar-hide">
      {/* 🚀 自动闭环一键启动按钮 */}
      <button
        onClick={() => {
          setAutoLoopState('WAITING_FOR_GEN');
          setLoopCount(0);
          onDirectSend('确认但仅生成整体方案设计');
        }}
        disabled={!isConnected || isGenerating}
        className={`whitespace-nowrap px-3 py-1.5 bg-gradient-to-r from-orange-500 to-red-500 border border-transparent text-white text-xs font-bold rounded-full hover:shadow-md hover:from-orange-600 hover:to-red-600 transition-all disabled:opacity-50`}
      >
        🚀 确认但仅生成完整方案设计（自审闭环）
      </button>

      {/* 手动单步：审核 */}
      <button
        onClick={() => {
          setAutoLoopState('IDLE');
          onDirectSend('审核整体方案设计');
        }}
        disabled={!isConnected || isGenerating}
        className={`whitespace-nowrap px-3 py-1.5 bg-white border text-xs rounded-full transition-colors shadow-sm disabled:opacity-50
          ${isAuditMode 
            ? 'border-purple-200 text-purple-700 hover:bg-purple-50 hover:border-purple-300' 
            : 'border-gray-200 text-gray-600 hover:bg-brand-50 hover:text-brand-600 hover:border-brand-200'}
        `}
      >
        单步: 审核整体方案设计
      </button>

      {/* 手动单步：修复 */}
      <button
        onClick={() => {
          setAutoLoopState('IDLE');
          onDirectSend('执行调整并输出优化后的整体方案设计');
        }}
        disabled={!isConnected || isGenerating}
        className={`whitespace-nowrap px-3 py-1.5 bg-white border text-xs rounded-full transition-colors shadow-sm disabled:opacity-50
          ${isAuditMode 
            ? 'border-purple-200 text-purple-700 hover:bg-purple-50 hover:border-purple-300' 
            : 'border-gray-200 text-gray-600 hover:bg-brand-50 hover:text-brand-600 hover:border-brand-200'}
        `}
      >
        单步: 执行调整并输出优化后的整体方案设计
      </button>
    </div>
  );
};